export type AgTextFilterModel = { filter?: string; filterType: "text"; type?: string };
export type AgNumberFilterModel = { filter?: number | string; filterType: "number"; type?: string };
export type AgSetFilterModel = { filterType: "set"; values?: (null | string)[] };
export type AgMultiFilterModel = {
	filterModels: Array<AgNumberFilterModel | AgSetFilterModel | AgTextFilterModel | null>;
	filterType: "multi";
};
export type AgFilterModel = AgMultiFilterModel | AgNumberFilterModel | AgSetFilterModel | AgTextFilterModel;

const hasFilterType = (value: unknown, expected: string): value is { filterType: string } =>
	typeof value === "object" && value !== null && (value as { filterType?: unknown }).filterType === expected;

export const isTextModel = (value: unknown): value is AgTextFilterModel => hasFilterType(value, "text");
export const isNumberModel = (value: unknown): value is AgNumberFilterModel => hasFilterType(value, "number");
export const isSetModel = (value: unknown): value is AgSetFilterModel => hasFilterType(value, "set");
export const isMultiModel = (value: unknown): value is AgMultiFilterModel => hasFilterType(value, "multi");

export const firstActiveSubmodel = (
	model: AgMultiFilterModel
): AgNumberFilterModel | AgSetFilterModel | AgTextFilterModel | undefined => {
	for (const sub of model.filterModels) {
		if (isTextModel(sub) || isNumberModel(sub) || isSetModel(sub)) return sub;
	}
	return undefined;
};
